/* Modules */
import React, { Component } from "react";
import { Provider } from "react-redux";
import asyncComponent from "./helpers/AsyncFunc";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
/* Importaciones de módulos */
const ErrorBoundary = asyncComponent(()=> import("./helpers/ErrorBoundary"));
const PublicRoutes = asyncComponent(()=> import("./router.js"));
// import TrackerContext from './services/openReplay'
/* Store */
import { store } from "./redux/store";
class DashApp extends Component {
  render() {
    return (
      <Provider store={store}>        
        <ErrorBoundary>        
            <GoogleReCaptchaProvider
              reCaptchaKey="6LfO9cwqAAAAAKRxzfYSsHkQYrXlNxuXObXIhO-H"
              language="es"
            >
              <PublicRoutes />
            </GoogleReCaptchaProvider>
        </ErrorBoundary>        
      </Provider>
    );
  }
}

export default DashApp;
